import React from "react";

function FitToDriveFix() {
  const handlePrint = () => {
    // This function triggers the browser's print dialog.
    window.print();
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center min-h-screen p-8 bg-gray-100 font-sans" id="FitToDriveFix">
        {/* Fit to Drive Declaration Content */}
        <div className="w-full max-w-2xl p-12 bg-white rounded-lg shadow-xl text-center border border-gray-300 transition-all duration-300">
          <h2 className="text-4xl font-bold uppercase mb-6 text-red-500">
            ⚠️ FIT TO DRIVE DECLARATION ⚠️
          </h2>
          <p className="text-xl mb-6 leading-relaxed">
            I, the undersigned driver, confirm that the vehicle is fit to drive and has passed all necessary checks, including tyre tread depth, brakes, lights, and other essential safety features, I also confirm I am well rested, healthy and not under the influence of drugs or alcohol.
          </p>
          <div className="mt-8 text-lg space-y-4">
            <p className="text-left w-full">
              <strong>Driver Name:</strong> ____________________________
            </p>
            <p className="text-left w-full">
              <strong>Driver Signature:</strong> ________________________
            </p>
            <p className="text-left w-full">
              <strong>Date:</strong> ________________________
            </p>
          </div>
        </div>
      </div>

      {/* Print Button */}
      <div className="fixed bottom-8 right-8">
        <button
          onClick={handlePrint}
          className="bg-blue-600 text-white font-bold py-3 px-6 rounded-full shadow-lg hover:bg-blue-700 transition-colors duration-200 focus:outline-none focus:ring-4 focus:ring-blue-300"
        >
          Print Declaration
        </button>
      </div>

      {/*
       * Print-Specific Styles
       * These styles are crucial for proper printing.
       */
      }
      <style>
        {`
          @media print {
            /* Hide the print button and any other elements not part of the flier. */
            body * {
              visibility: hidden;
            }

            /* Make the declaration and its children visible. */
            #FitToDriveFix, #FitToDriveFix * {
              visibility: visible;
            }
            
            #FitToDriveFix {
              /* Remove all screen-specific positioning and centering. */
              position: absolute !important;
              top: 0 !important;
              left: 0 !important;
              
              /* Ensure the content fits within the A4 page. */
              width: 100% !important;
              max-width: none !important;
              min-height: auto !important;
              height: auto !important;
              
              /* Reset padding and background to avoid conflicts. */
              padding: 0 !important;
              background-color: white !important;
              
              /* Override Tailwind's flexbox to allow content to flow naturally. */
              display: block !important;
            }
            
            /* Target the inner container for print-specific styling. */
            #FitToDriveFix > div {
              width: 100% !important;
              padding: 20mm !important; /* Set a clear margin for printing */
              box-shadow: none !important;
              border: none !important;
              background-color: white !important;
            }

            /* Adjust font sizes for a professional print look. */
            h2 {
              font-size: 28px !important;
              margin-bottom: 15px !important;
            }

            p {
              font-size: 16px !important;
            }

            .space-y-4 > p {
              text-align: left !important;
              padding-left: 0 !important;
            }

            /* Set up the A4 page. */
            @page {
              size: A4 portrait;
              margin: 20mm;
            }
          }
        `}
      </style>
    </>
  );
}

export default FitToDriveFix;